import React from 'react';
import { View, StyleSheet } from 'react-native';
import { createShimmerPlaceholder } from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';
import { ThemedView } from '@app/theme';

const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

interface ShimmerProps {
  width?: number | string;
  height?: number;
  style?: any;
  borderRadius?: number;
}

export const Shimmer = ({ width, height, style, borderRadius = 4 }: ShimmerProps) => {
  return (
    <ShimmerPlaceholder
      style={[styles.shimmer, { width, height, borderRadius }, style]}
      shimmerColors={['#E4E7EC', '#F2F4F7', '#E4E7EC']}
      shimmerStyle={styles.shimmerStyle}
    />
  );
};

const styles = StyleSheet.create({
  shimmer: {
    backgroundColor: '#E4E7EC',
  },
  shimmerStyle: {
    borderRadius: 4,
  },
}); 